import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Checkbox } from '@/components/ui/checkbox';
import { MessageSquare, Save } from 'lucide-react';

export default function TicketEmailCard({ 
  ticketConfig, 
  setTicketConfig, 
  onSave, 
  saving 
}) {
  return (
    <Card className="border-border bg-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2" style={{ fontFamily: 'Manrope' }}>
          <MessageSquare className="w-5 h-5 text-blue-500" />
          Notifiche Ticket
        </CardTitle>
        <CardDescription>
          Configura l'email per ricevere notifiche su nuovi ticket e risposte
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="ticket_email">Email Notifiche Ticket</Label>
          <Input
            id="ticket_email"
            type="email"
            placeholder="supporto@tuodominio.com"
            value={ticketConfig.ticket_notification_email || ''}
            onChange={(e) => setTicketConfig({ ...ticketConfig, ticket_notification_email: e.target.value })}
            data-testid="ticket-email-input"
          />
          <p className="text-xs text-muted-foreground">
            Questo indirizzo ricevera' una notifica per ogni nuovo ticket e ogni risposta
          </p>
        </div>

        <div className="space-y-3 pt-2">
          <div className="flex items-center space-x-2">
            <Checkbox
              id="notify_new_ticket"
              checked={ticketConfig.notify_on_new_ticket !== false}
              onCheckedChange={(checked) => setTicketConfig({ ...ticketConfig, notify_on_new_ticket: checked })}
              data-testid="notify-new-ticket-checkbox"
            />
            <Label htmlFor="notify_new_ticket" className="cursor-pointer">
              Notifica nuovi ticket
            </Label>
          </div>
          
          <div className="flex items-center space-x-2">
            <Checkbox
              id="notify_ticket_reply"
              checked={ticketConfig.notify_on_ticket_reply !== false}
              onCheckedChange={(checked) => setTicketConfig({ ...ticketConfig, notify_on_ticket_reply: checked })}
              data-testid="notify-ticket-reply-checkbox"
            />
            <Label htmlFor="notify_ticket_reply" className="cursor-pointer">
              Notifica risposte ai ticket
            </Label>
          </div>
        </div>

        <Button 
          onClick={onSave} 
          disabled={saving}
          className="w-full sm:w-auto"
          data-testid="save-ticket-email-btn"
        >
          <Save className="w-4 h-4 mr-2" />
          {saving ? 'Salvataggio...' : 'Salva Configurazione'}
        </Button>

        {ticketConfig.configured && (
          <p className="text-xs text-green-500">
            ✓ Email notifiche ticket configurata
          </p>
        )}
      </CardContent>
    </Card>
  );
}
